<template>
    <ym-layout>
        <div class="container overflow">
            <div class="menu pr">
                <h1>委托找货</h1>
            </div>
            <div class="searchBox bgfff">
                <dl class="timberCategory">
                    <dt>木材类别</dt>
                    <dd>
                        <div>
                            <a v-for="item in api_categories.top" @click="handleCatagoryClick(item)"
                               :class="{ current: search_options.categorys_top == item }">{{ item }}</a>
                        </div>
                        <div>
                            <a v-for="item in api_categories.sub" @click="searchFirst(item)"
                               :class="{current: search_options.fir_category == item}">{{ item }}</a>
                        </div>
                    </dd>
                </dl>
                <dl>
                    <dt>树种</dt>
                    <dd>
                        <div v-for="item in search_form.product_name" @click="searchOnes('product_name', item)">
                            <a v-if="item == '全部'" :class="{ current: search_options.product_name == '' }">{{item}}</a>
                            <a v-else :class="{ current: search_options.product_name == item }">{{item}}</a>
                        </div>
                    </dd>
                </dl>
                <dl>
                    <dt>等级</dt>
                    <dd>
                        <div v-for="item in search_form.grade" @click="searchOnes('grade', item)">
                            <a v-if="item == '全部'" :class="{ current: search_options.grade == '' }">{{item}}</a>
                            <a v-else :class="{ current: search_options.grade == item }">{{item}}</a>
                        </div>
                    </dd>
                </dl>
            </div>
            <div class="filter bbf bbn margintop15">
                <dl class="sortord left">
                    <dt>排序：</dt>
                    <dd :class="{current : search_options.ordering == ''}" @click="orderItem('')">默认</dd>
                    <dd :class="{current : search_options.ordering == '-deadline'}" @click="orderItem('-deadline')">
                        剩余天数
                    </dd>
                </dl>
                <div class="total right">
                    <div>共<b>{{more_count}}</b>条信息</div>
                </div>
            </div>
            <div class="entrust content bbf">
                <div class="list left bgfff" style="height:auto">
                    <table class="table">
                        <thead>
                        <tr class="bgf5">
                            <td>类别</td>
                            <td>树种</td>
                            <td>等级</td>
                            <td>找货地址</td>
                            <td>截止时间</td>
                            <td>剩余天数</td>
                            <td style="text-align: left">木材描述</td>
                        </tr>
                        </thead>
                        <tbody v-for="item in results">
                        <tr>
                            <td>{{item.category_type}}</td>
                            <td>{{item.product_name}}</td>
                            <td>{{item.grade}}</td>
                            <td>{{item.location}}</td>
                            <td>{{item.deadline}}</td>
                            <td>{{item.days}}</td>
                            <td class="txtbreak" style="text-align: left">{{item.desc}}</td>
                        </tr>
                        </tbody>
                    </table>
                </div>
                <div class="tool left">
                    <h2 class="txtcenter green ">委托找货</h2>
                    <el-form :model="trust_form" :rules="rules" ref="trust_form">
                        <dl>
                            <dt class="left pr">木材类别：</dt>
                            <dd class="left">
                                <el-form-item style="margin-bottom: 0px;" prop="category">
                                    <el-select v-model="trust_form.category" placeholder="选择类别">
                                        <template v-for="top in category_select">
                                            <el-option-group v-for="(value, key) in top" :label="key" :key="key">
                                                <el-option v-for="(item, index) in value" :lable="item" :value="item" :key="value">
                                                </el-option>
                                            </el-option-group>
                                        </template>
                                    </el-select>
                                </el-form-item>
                            </dd>
                        </dl>
                        <dl>
                            <dt class="left pr">木材树种：</dt>
                            <dd class="left">
                                <el-form-item style="margin-bottom: 0px;" prop="product_name">
                                    <el-input v-model="trust_form.product_name" placeholder="请输入木材树种"></el-input>
                                </el-form-item>
                            </dd>
                        </dl>
                        <dl>
                            <dt class="left pr">木材等级：</dt>
                            <dd class="left pr">
                                <el-form-item style="margin-bottom: 0px;" prop="grade">
                                    <el-input v-model="trust_form.grade" placeholder="请输入木材等级"></el-input>
                                </el-form-item>
                            </dd>
                        </dl>
                        <dl>
                            <dt class="left pr">找货地址：</dt>
                            <dd class="left pr">
                                <el-form-item style="margin-bottom: 0px;" prop="location">
                                    <el-input v-model="trust_form.location" placeholder="请输入找货地址"></el-input>
                                </el-form-item>
                            </dd>
                        </dl>
                        <dl>
                            <dt class="left pr">截止时间：</dt>
                            <dd class="left pr">
                                <el-form-item style="margin-bottom: 0px;" prop="deadline">
                                    <div class="block" >
                                        <el-date-picker v-model="trust_form.deadline" type="date" placeholder="选择日期"
                                                        align="right" :picker-options="pickerOptions0">
                                        </el-date-picker>
                                    </div>
                                </el-form-item>
                            </dd>
                        </dl>
                        <dl style="height: auto;padding-bottom: 24px;">
                            <dt class="left pr">木材描述：</dt>
                            <dd class="left">
                                <el-form-item style="margin-bottom: 0px; width: 150px;" prop="desc">
                                    <el-input type="textarea" :autosize="{ minRows: 3, maxRows: 6}" v-model="trust_form.desc" placeholder="品牌、规格、方数"></el-input>
                                </el-form-item>
                            </dd>
                        </dl>
                        <el-form-item style="margin-bottom: 0px;">
                            <el-button style="width: 40%; height: 26px; font-size: 0.8rem" class="btn093 btn-big"
                                       @click="submitTrust('trust_form')">提交
                            </el-button>
                            <el-button style="width: 40%; height: 32px; font-size: 0.8rem" class="btn093 btn-big"
                                       @click="resetForm('trust_form')">重置
                            </el-button>
                            <p class="txtcenter color999" style="color: #888;">咨询热线：400-723-0868</p>
                        </el-form-item>
                    </el-form>
                </div>
            </div>
            <template v-if="isLogin">
                <el-pagination @current-change="handleCurrentChange" :page-size="15" :total="more_count"
                               layout="prev, pager, next" style="text-align: center;margin: 10px 0 10px 0;">
                </el-pagination>
            </template>
            <template v-else-if="more_count < 15">
                    <el-pagination
                        @current-change="handleCurrentChange"
                        :page-size="15"
                        :total="more_count"
                        layout="prev, pager, next" style="text-align: center;margin: 10px 0 10px 0;">
                    </el-pagination>
                </template>
            <template v-else>
                    <div class="unlogin">
                        <a href="/login">登录</a> 即可免费查看更多现货资源。<a href="/reg" class="bgff9800">免费注册</a>
                    </div>
            </template>
        </div>

    </ym-layout>
</template>
<script>
    import moment from 'moment'
    export default {
        data() {
            return {
                pickerOptions0: {
                    disabledDate(time) {
                        return time.getTime() < Date.now() - 8.64e7;
                    }
                },
                isLogin: false,
                api_categories: {},
                search_form: {
                    product_name: '',
                    grade: ''
                },
                results: {},
                category_select: [],
                trust_form: {
                    category: '针叶锯材',
                    product_name: '',
                    grade: '',
                    deadline: '',
                    desc: '',
                    location: ''
                },
                search_options: {
                    categorys_top: '锯材',
                    fir_category: '',
                    product_name: '',
                    grade: '',
                    ordering: ''
                },
                trustType: '',
                more_count: 0,
                rules: {
                    category: [{
                        required: true,
                        message: '请选择木材类型',
                        trigger: 'blur'
                    }],
                    deadline: [{
                        type: 'date',
                        required: true,
                        message: '请选择截止日期',
                        trigger: 'blur'
                    }],
                    product_name: [{
                        required: true,
                        message: '请输入木材树种',
                        trigger: 'blur'
                    }],
                    grade: [{
                        required: true,
                        message: '请输入木材等级',
                        trigger: 'blur'
                    }],
                    location: [{
                        required: true,
                        message: '请输入找货地址',
                        trigger: 'blur'
                    }],
                    desc: [{
                        required: true,
                        message: '请输入木材描述',
                        trigger: 'blur'
                    }]
                }
            }
        },

        activated: function () {
            this.showResult();
            this.bus.$on('isLogin', function (val) {
                this.isLogin = val
            }.bind(this));
            this.trust_form.deadline = this.nextWeek();
            this.get_source_city()
        },

        methods: {
            nextWeek() {
                let date = new Date();
                date.setDate(date.getDate() + 14);
                return date
            },
            sendRequest() {
                this.$http.get(this.ym_api + '/support/trust_read/', {
                    params: this.search_options
                }).then((resp) => {
                    this.more_count = parseInt(resp.data.count);
                    this.results = resp.data.results;
                    this.search_form = resp.data.search_options;
                    this.search_form.product_name.unshift('全部');
                    this.search_form.grade.unshift('全部')
                }).catch((error) => {
                    this.result = error.response.data;
                    console.log(error)
                })
            },
            get_source_city() {
                this.$http.get(this.ym_api + '/get_source_city/').then((resp) => {
                    this.trust_form.location = resp.data.city;
                }).catch((error) => {
                    console.log(error)
                })
            },
            showResult() {
                this.$http.get(this.ym_api + '/support/categorys/', {
                    params: this.search_options
                }).then((resp) => {
                    this.api_categories = resp.data;
                    this.category_select = resp.data.all;
                });
                this.sendRequest();
            },
            handleCatagoryClick(item) {
                this.search_options = {
                    categorys_top: item,
                    fir_category: item,
                    product_name: '',
                    brand: '',
                    origin: '',
                    grade: '',
                    ordering: ''
                }
                this.$http.get(this.ym_api + '/support/categorys/', {
                    params: this.search_options
                }).then((resp) => {
                    this.api_categories = resp.data
                })
                this.sendRequest()
            },
            searchFirst(item) {
                this.search_options.fir_category = item;
                this.search_options.product_name = '';
                this.search_options.origin = '';
                this.search_options.grade = '';
                this.search_options.brand = '';
                this.search_options.ordering = '';
                this.sendRequest()
            },
            searchOnes(name, val) {
                this.search_options.ordering = '';
                if (name === 'product_name') {
                    if (val === '全部') {
                        this.search_options.product_name = '';
                        this.sendRequest()
                    } else {
                        this.search_options.product_name = val;
                        this.sendRequest()
                    }
                } else if (name === 'grade') {
                    if (val === '全部') {
                        this.search_options.grade = '';
                        this.sendRequest()
                    } else {
                        this.search_options.grade = val;
                        this.sendRequest()
                    }
                }
            },
            handleCurrentChange(val) {
                this.search_options.page = val;
                this.sendRequest()
            },
            orderItem(val) {
                this.ordering = val;
                this.search_options.ordering = this.ordering;
                this.sendRequest()
            },
            submitTrust(formName) {
                this.$refs[formName].validate((valid) => {
                    if (valid) {
                        let isLogin = Boolean(window.localStorage.getItem('userhashid'));
                        if (!isLogin) {
                            this.$router.push({
                                name: '001-2',
                                params: {
                                    h: true
                                }
                            })
                        } else {
                            this.trust_form.deadline = moment(this.trust_form.deadline).format('YYYY-MM-DD')
                            let val = this.trust_form.category;
                            let name = this.category_select;
                            for (let i = 0; i < name.length; i++) {
                                for (let e in name[i]) {
                                    for (let c in name[i][e]) {
                                        if (val === name[i][e][c]) {
                                            this.trust_form.category = c;
                                        }
                                    }
                                }
                            };
                            this.$http.post(this.ym_api + '/support/trust/', this.trust_form).then((resp) => {
                                this.showResult();
                                this.trust_form.category = '针叶锯材';
                                this.trust_form.deadline = this.nextWeek();
                                this.trust_form.product_name = '';
                                this.trust_form.desc = '';
                                this.trust_form.grade = '';
                                this.$notify({
                                    title: '成功',
                                    message: '找货信息已提交',
                                    type: 'success'
                                });
                            }).catch((error) => {
                                console.log('error', error)
                                this.$notify.error({
                                    title: '错误',
                                    message: '找货信息提交失败'
                                });
                                this.result = error.response.data
                            });
                        }
                    } else {
                        console.log('error submit!!');
                        return false;
                    }
                });
            },
            resetForm(formName) {
                this.$refs[formName].resetFields();
            }
        }
    }
</script>
<style>
    .el-dialog__body {
        padding: 15px 20px 20px 0px;
        font-size: .8rem;
        color: #999 !important;
    }

    .el-dialog__header {
        font-size: 16px;
        padding: 20px 20px 35px;
        border-bottom: 1px solid #e2e2e2
    }

    .el-radio__label {
        font-family: "\5FAE\8F6F\96C5\9ED1", Arial, Helvetica, sans-serif;
        color: #666;
        font-size: .8rem;
        line-height: 22px;
    }

    .el-input__icon + .el-input__inner {
        width: 150px;
    }

    .el-date-editor.el-input {
        width: 150px;
    }

    .tool dd {
        padding-top: 6px;
    }

    .tool dd input {
        width: 150px;
        height: 38px;
    }

    .tool dd span {
        top: 0px;
        right: 0px;
    }

    .el-form-item__label {
        font-size: .8rem;
    }

    .el-button--success {
        color: #fff;
        background-color: #093;
        border-color: #093;
    }

    .el-button:hover {
        border-color: #083;
        background: #083;
        color: #fff;
        text-decoration: none;
    }

    .tool dl {
        height: 60px;
        line-height: 52px;
        margin-bottom: 0px;
    }

    .tool dt {
        width: auto;
    }

</style>



// WEBPACK FOOTER //
// trust.vue?27ec250d